import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import { Component, Input, OnInit, Optional, Self } from '@angular/core';

@Component({
    selector: 'c-radio',
    templateUrl: './radio.component.html',
    styleUrls: ['./radio.component.scss'],
    standalone: false
})
export class RadioComponent<T = any> implements OnInit, ControlValueAccessor {
  @Input() label: string | undefined;
  @Input() set options(values: any[]) {
    this._options = values;
  }
  @Input() showError = false;
  @Input() selected: string = null;

  _options = [];

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  get hasErrors(): boolean {
    return this.showError && this.control?.errors && this.control?.touched;
  }

  get control() {
    return this.ngControl?.control as FormControl;
  }

  ngOnInit(): void {
    if (this.selected) {
      this.control.patchValue(this.selected);
    }
  }

  writeValue(value: any): void {}

  onChange = (value: T) => {};
  onTouched = () => {};

  registerOnChange(fn: (value: T) => void): void {
    this.onChange = fn;
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  registerOnTouched(fn: () => {}): void {
    this.onTouched = fn;
  }
}
